import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b452038")

_pushScopeId("data-v-8b452038")
const _hoisted_1 = {
  class: "movement-list-item",
  "data-test": "movementListItem"
}
const _hoisted_2 = { class: "movement" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "movement__pond" }
const _hoisted_5 = { class: "movement__datetime" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "movement__fish" }
const _hoisted_8 = { class: "movement__quantity" }
const _hoisted_9 = {
  key: 0,
  class: "section"
}
const _hoisted_10 = { class: "movement__notes" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['action', _ctx.actionStyle]
    }, null, 2),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.movement.pond.name), 1),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.date(_ctx.movement.datetime)), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.movement.fish.name), 1),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.movement.quantity) + " UN", 1)
      ]),
      (_ctx.movement.notes)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, "\"" + _toDisplayString(_ctx.movement.notes) + "\"", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})